import {
  MinusCircleOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  message,
  Radio,
  Row,
  Select,
  Tooltip,
} from 'antd';
import { Option } from 'antd/es/mentions';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { Link, useNavigate, useParams } from 'react-router-dom';
import initialTermsCondition from '../../Common/intialTermsCondition';
import { ReactComponent as Back } from '../../Images/Back.svg';
import {
  fetchCustomerDropdown,
  fetchCustomerList,
  resetCurrentCustomerPage,
  resetCustomerList,
} from '../../slices/customer';
import {
  fetchDieProfileById,
  fetchDieProfileDropdown,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDieQuotationById,
  updateDieQuotation,
} from '../../slices/die-quotation';
import { debounce } from 'lodash';

function EditDieQuotation() {
  const [form] = Form.useForm();
  const { id } = useParams();
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [minimumOrderQty, setMinimumOrderQty] = useState('less_than_300');
   const { data: settingData } = useSelector(state => state.setting);
  const [dieRight, setDieRight] = useState('');
  const [editorValue, setEditorValue] = useState(initialTermsCondition);
  const [items, setItems] = useState([{ key: 0 }]);
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [searchAlloy, setSearchAlloy] = useState('');
  const navigate = useNavigate();
  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const [selectedDieProfile, setSelectedDieProfile] = useState([]);

  const getClassNameDieProfile = (index) => {
    const value = selectedDieProfile[index];
    if (!value) return 'active-option';

    const selected = dieProfileList.find(item => item.id === value);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const {
    list: customerList,
    loading: customerLoading,
    currentPage: customerCurrentPage,
    hasMore: customerHasMore,
  } = useSelector(state => state.customer);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const getClassName = () => {
    const selected = customerList.find(item => item.id === selectedCustomer);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const [selectedAlloy, setSelectedAlloy] = useState([]);
  const getClassAlloy = () => {
    const selected = alloyList.find(item => item.id === selectedAlloy);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameAlloy = (index) => {

    const value = selectedAlloy[index];
    if (!value) return 'active-option';
    const selected = alloyList.find(item => item.id === value);

    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';

  };
  const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false);
  const [customerForm] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false);
  const handleAlloy = (selected, option, index) => {
    const updatedDetails = form
      .getFieldValue('die_quotation_details')
      .map((item, i) => (i === index ? { ...item, alloy: selected } : item));

    form.setFieldsValue({ die_quotation_details: updatedDetails });
  };
  useEffect(() => {
    const fetchDieQuotation = async () => {
      try {
        dispatch(fetchDieQuotationById(id))
          .unwrap()
          .then(response => {
            console.log(response);
            if (response?.data) {
              const quotationData = response.data;

              form.setFieldsValue({
                customer: quotationData.customer.id,
                minimum_order_qty: quotationData.minimum_order_qty,
                die_right: quotationData.die_right,
                sample_delivery: quotationData.sample_delivery
                  ? quotationData.sample_delivery
                  : null,
                terms_and_condition: quotationData.terms_and_condition,
                die_quotation_details: quotationData.die_quotation_details.map(
                  detail => ({
                    id: detail ? detail.id : null,
                    profile_no: detail.profile_no
                      ? {
                        label: detail.profile_no.die_number,
                        value: detail.profile_no.id,
                      }
                      : undefined,

                    customer_reference_no: detail.customer_reference_no,
                    alloy: detail.alloy
                      ? {
                        label: `${detail.alloy.alloy_code}${detail.alloy.standard_name ? ' - ' + detail.alloy.standard_name : ''}`,
                        value: detail.alloy.id,
                      }
                      : null,
                    press_capacity: detail.press_capacity,
                    unit_of_measurement: detail.unit_of_measurement,
                    quantity: detail.quantity ? detail.quantity : 1,
                    profile_devlopment_cost: detail.profile_devlopment_cost,
                  }),
                ),
              });


              setMinimumOrderQty(quotationData.minimum_order_qty);
              setDieRight(quotationData.die_right);
              setEditorValue(quotationData.terms_and_condition);

              setSelectedCustomer(quotationData.customer.id,);

              const firstDetail = quotationData.die_quotation_details?.[0];
              if (
                quotationData.die_quotation_details &&
                quotationData.die_quotation_details.length > 0
              ) {
                setSelectedDieProfile(
                  quotationData.die_quotation_details
                    .map(item => item.profile_no?.id)
                    .filter(Boolean)
                );

                setSelectedAlloy(
                  quotationData.die_quotation_details
                    .map(item => item.alloy?.id)
                    .filter(Boolean)
                );
              }


              if (
                quotationData.die_quotation_details &&
                quotationData.die_quotation_details.length > 0
              ) {
                setItems(
                  quotationData.die_quotation_details.map((_, index) => ({
                    key: index,
                  })),
                );
              }
            }
          })
          .catch(error => {
            console.error('Fetch Die Quotation Failed:', error);
          });
      } catch (error) {
        console.error('Error fetching die quotation:', error);
      }
    };
    fetchDieQuotation();
  }, [id, dispatch, form]);

  useEffect(() => {
    if (form.getFieldValue('terms_and_condition')) {
      setEditorValue(form.getFieldValue('terms_and_condition'));
    }
  }, [form.getFieldValue('terms_and_condition')]);

  const handleChange = content => {
    setEditorValue(content);
    form.setFieldsValue({ terms_and_condition: content });
  };


  useEffect(() => {
    dispatch(
      fetchCustomerList({
        page: 1,
        pagesize: 1000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );

    dispatch(
      fetchAlloyDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );

    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );

    dispatch(
      fetchCustomerDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      })
    );

    dispatch(resetDieProfileList());
    dispatch(resetCurrentCustomerPage());
    dispatch(resetCurrentAlloyListPage());
    dispatch(resetDieProfileData());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
  }, [dispatch, page, pagesize, search, orderBy]);

  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      setSearchCustomer(value);
      dispatch(resetCustomerList());
      dispatch(fetchCustomerList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerList({ page: 1, pagesize: 1000 }));
    }
  };
  const handleSearchAlloy = value => {
    setSearchAlloy(value);

    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const addItem = () => {
    setItems([...items, { key: items.length }]);
  };
  const onScrollCustomer = async event => {
    const target = event.target;
    if (
      !customerLoading &&
      customerHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchCustomerList({ page: customerCurrentPage, pagesize: 1000 }));
    }
  };

  const removeItem = index => {
    const newItems = items.filter((_, idx) => idx !== index);
    setItems(newItems);
  };
  const showCustomerModal = () => {
    setIsCustomerModalVisible(true);
  };
  const handleDieRightChange = e => {
    const value = e.target.value;
    setDieRight(value);
  };
  const handleDieProfileChange = async (value, index) => {
    setSelectedDieProfile(value);
    const updatedQuotationDetails = [
      ...form.getFieldValue('die_quotation_details'),
    ];

    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      profile_no: value?.value, // Set the selected profile ID
    };

    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();
      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_no: customerRefNo,
        };

        form.setFieldsValue({
          quotation_details: updatedQuotationDetails,
          customer_reference_no: customerRefNo,
        });
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }

    form.setFieldsValue({
      die_quotation_details: updatedQuotationDetails,
    });
  };

  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 100,
        search: value || '',
      }),
    );
  }, 300);

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 100 }));
    }
  };

  const onScrollDieProfile = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;
      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 100,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const handleCustomerModalCancel = () => {
    setIsCustomerModalVisible(false);
    customerForm.resetFields();
  };
  const handleSaveCustomer = () => {
    customerForm
      .validateFields()
      .then(values => {
        setIsCustomerModalVisible(false);
        customerForm.resetFields();
      })
      .catch(errorInfo => { });
  };
  const handleChangeCustomer = value => {
    setSearchCustomer(value);
    setSelectedCustomer(value);
  };
  const handleFinish = values => {
    setBtnLoading(true);

    const DieQuotationDetails = values.die_quotation_details.map(detail => ({
      id: detail ? detail.id : null,
      profile_no: detail.profile_no.value,
      customer_reference_no: detail.customer_reference_no,
      alloy: detail.alloy
        ? typeof detail.alloy === 'object'
          ? detail.alloy.value
          : detail.alloy
        : null,
      press_capacity: detail.press_capacity,
      unit_of_measurement: detail.unit_of_measurement,
      quantity: detail.quantity ? detail.quantity : 1,
      profile_devlopment_cost: detail.profile_devlopment_cost,
    }));

    const payload = {
      customer: values.customer,
      die_right: values.die_right,
      minimum_order_qty: values.minimum_order_qty,
      sample_delivery: values.sample_delivery,
      terms_and_condition: values.terms_and_condition,
      die_quotation_details: DieQuotationDetails,
    };

    dispatch(updateDieQuotation({ id: id, values: payload }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Die Quotation Updated Successfully!');
          navigate('/die-quotation-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Edit Die Quotation</h2>
          <div className="bredcrumbwrp">
            <Link className="back" onClick={(() => { navigate(-1) })}>
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/die-quotation-list">Die Quotations</Link> },
                { title: 'Edit Die Quotation' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          form={form}
          onFinish={handleFinish}
          layout="vertical"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                name="customer"
                label="Customer Name"
                rules={[
                  { required: true, message: 'Please select company name' },
                ]}
              >
                <Select
                  value={searchCustomer}
                  placeholder="Please Select Company Name"
                  style={{ width: 'calc(100% - 40px)' }}
                  onChange={value => {
                    form.setFieldValue('customer', value); // Update field value
                    form.validateFields(['customer']); // Trigger validation
                    handleChangeCustomer(value);
                  }}
                  allowClear
                  showSearch={true}
                  onSearch={handleSearchCustomer}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  className={getClassName()}
                >
                  {[
                    ...new Map(
                      customerList.map(item => [item.id, item]),
                    ).values(),
                  ].map((el, index) => (
                    <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                      {el.customer_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="Minimum Order Qty (Kg)"
                name="minimum_order_qty"
                rules={[{ required: true, message: 'Please select an option' }]}
              >
                <div className="flex items-center">
                  <Radio.Group
                    value={minimumOrderQty}
                    onChange={e => setMinimumOrderQty(e.target.value)}
                  >
                    <Radio value="<300">&lt; 300</Radio>
                    <Radio value="300 - 500">300 - 500</Radio>
                    <Radio value=">500">&gt; 500</Radio>
                  </Radio.Group>
                </div>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="Die Right" name="die_right">
                <Radio.Group value={dieRight} onChange={handleDieRightChange}>
                  <Radio value="Own">{settingData?.company_settings?.company_name}</Radio>
                  <Radio value="Customer">Customer</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} xl={6}>
              <div style={{ marginBottom: '3px' }}>
                <label className="customlabel">Sample Delivery</label>{' '}
                <Tooltip
                  placement="topLeft"
                  title=" Within __ weeks from the date of drawing approval and die cost."
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
              <Form.Item name="sample_delivery" label="">
                <Input
                  placeholder="Enter Sample Delivery"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ sample_delivery: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="die_quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      wrap={false}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'profile_no']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select section number',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Section Number"
                                style={{ width: '100%' }}
                                onChange={handleDieProfileChange}
                                labelInValue
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                showSearch={true}
                                allowClear
                                onClear={() => {
                                  dispatch(resetDieProfileData());
                                  dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 100 }));
                                }}
                                onSearch={handleSearchDieProfile}
                                value={searchDieProfile}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                dropdownRender={menu => <>{menu}</>}
                                className={getClassNameDieProfile(name)}
                              >
                                {dieProfileList.map(el => (
                                  <Option key={el.id} value={el.id} disabled={el.deleted === 1} >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              name={[name, 'customer_reference_no']}
                              label="Customer Reference Number"

                            >
                              <Input placeholder="Please Enter Customer Reference Number" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select valid alloy',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Alloy"
                                style={{ width: '100%' }}
                                loading={alloyLoading}
                                onPopupScroll={onScrollCustomer}
                                notFoundContent={
                                  customerLoading ? 'Loading...' : 'No options'
                                }
                                value={searchAlloy}
                                onChange={(value, option) => {
                                  handleAlloy(value, option);
                                  setSelectedAlloy(value);
                                }}
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;

                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();

                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => (
                                  <>
                                    {menu}
                                  </>
                                )}
                                className={getClassNameAlloy(name)}
                              >
                                {alloyList.map(el => (
                                  <Option key={el.id} value={el.id} disabled={el.deleted === 1}>
                                    {el?.alloy_code} - {el.standard_name}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'press_capacity']}
                              label="Press Capacity (Tonnage)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid press capacity',
                                },
                              ]}
                            >
                              <Input placeholder="Press Capacity" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'unit_of_measurement']}
                              label="Unit Of Measurement"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Please enter valid unit of measurement',
                                },
                              ]}
                            >
                              <Input placeholder="Unit Of Measurement" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'quantity']}
                              label="Quantity"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid quantity',
                                },
                                {
                                  validator: (_, value) => {
                                    if (value && isNaN(value)) {
                                      return Promise.reject(
                                        'Only numbers are allowed',
                                      );
                                    }
                                    if (
                                      value &&
                                      parseFloat(value) > 9999999999
                                    ) {
                                      return Promise.reject('Value too large');
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="Enter Quantity" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'profile_devlopment_cost']}
                              label="Profile Devlopment Cost"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid press capacity',
                                },
                                {
                                  validator: (_, value) => {
                                    if (value && isNaN(value)) {
                                      return Promise.reject(
                                        'Only numbers are allowed',
                                      );
                                    }
                                    if (
                                      value &&
                                      parseFloat(value) > 9999999999
                                    ) {
                                      return Promise.reject('Value too large');
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              danger
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '0px',
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}

                  <div className="w-100 flex justify-end ">
                    <Button
                      type="primary"
                      onClick={() => {
                        if (fields.length < 15) {
                          add();
                        } else {
                          message.error('You can only add up to 15 records.');
                        }
                      }}
                      icon={<PlusOutlined />}
                    >
                      Add Item
                    </Button>
                  </div>
                </>
              )}
            </Form.List>
          </div>

          <Col xs={24}>
            <Form.Item
              name="terms_and_condition"
              label="Terms & Condition"
              rules={[{ required: true, message: 'Terms & Condition' }]}
              valuePropName="content"
            >
              <ReactQuill
                value={editorValue}
                onChange={handleChange}
                theme="snow"
                modules={{
                  toolbar: [
                    [{ header: '1' }, { header: '2' }, { font: [] }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['bold', 'italic', 'underline'],
                    [{ align: [] }],
                    ['link', 'image'],
                    ['blockquote', 'code-block'],
                  ],
                }}
              />
            </Form.Item>
          </Col>
          <div className="flex justify-end">
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
              Edit Die Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditDieQuotation;
